import _ from 'lodash'

export default class BlackBoxInventarios {
    constructor(){
        this.lista = []
        this.filtroAprobacionSei = []
    }
    reset() {
        this.lista = []
        this.filtroAprobacionSei = []
    }
    add(inventario){
        this.lista.push(inventario)
    }
    actualizarInventario(inventarioActualizado) {
        console.log(inventarioActualizado)
        this.lista = this.lista.map(inventario=> {
            if (inventario.inv_idInventario == inventarioActualizado.inv_idInventario) {
                return inventarioActualizado
            }
            return inventario
        })
        this.actualizarFiltros()
    }
    actualizarFiltros(){
        this.filtroAprobacionSei = _.chain(this.lista)
            .map(inventario=>{
                let valor = inventario.inv_aprobacionSEI
                let texto = inventario.inv_aprobacionSEITexto
                // entrega la opcion si ya existe (para mantener el estado del campo 'seleccionado', o la crea si no existe
                let opcion = _.find(this.filtroAprobacionSei, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
    }
    reemplazarFiltro(nombreFiltro, filtroActualizado) {
        if(this[nombreFiltro]) {
            this[nombreFiltro] = filtroActualizado
        }else{
            console.error(`Filtro ${nombreFiltro} no existe.`)
        }
    }
    getListaFiltrada(){
        this.actualizarFiltros()
        return{
            inventariosFiltrados: _.chain(this.lista)
                .filter(inventario=>{
                    return _.find(this.filtroAprobacionSei, {'valor': inventario.inv_aprobacionSEI, 'seleccionado': true})
                })
                .value(),
            filtros: {
                filtroAprobacionSei: this.filtroAprobacionSei
            }

        }
    }
}


// WEBPACK FOOTER //
// ./frontEnd/inventarios/diferencias-inventarios/BlackBoxInventarios.js